import React, { FC } from 'react';
import { AiOutlineCheck } from 'react-icons/ai';

interface StepProgressProps {
  currentStep: number;
  steps: string[];
}

const StepProgress: FC<StepProgressProps> = ({ currentStep, steps }) => {
  return (
    <div className="flex items-center justify-center w-full px-4 py-6">
      {steps.map((label, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const isUpcoming = index > currentStep;

        return (
          <React.Fragment key={label}>
            {/* Step circle + label */}
            <div className="flex flex-col items-center" style={{ minWidth: 80 }}>
              <div
                className="flex items-center justify-center rounded-full transition-colors"
                style={{
                  width: 32,
                  height: 32,
                  backgroundColor: isCompleted || isActive ? 'var(--main)' : '#FFFFFF',
                  border: isUpcoming ? '2px solid #D1D5DB' : '2px solid var(--main)',
                }}
              >
                {isCompleted ? (
                  <AiOutlineCheck size={16} color="#FFFFFF" />
                ) : (
                  <div
                    className="rounded-full"
                    style={{
                      width: 10,
                      height: 10,
                      backgroundColor: isActive ? '#FFFFFF' : '#D1D5DB',
                    }}
                  />
                )}
              </div>
              <span
                className="text-xs font-medium mt-2 text-center"
                style={{
                  color: isCompleted || isActive ? 'var(--main)' : '#9CA3AF',
                }}
              >
                {label}
              </span>
            </div>

            {/* Connector line */}
            {index < steps.length - 1 && (
              <div
                className="flex-1 mx-2"
                style={{
                  height: 2,
                  backgroundColor: index < currentStep ? 'var(--main)' : '#D1D5DB',
                  marginBottom: 24,
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepProgress;
